import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";

const GetAllRefunds = (page = 1, size = 50, status = "") => {
    return useQuery(
        ["get-all-refunds", page, size, status],
        () =>
            request({
                url: "/payment/getAllRefunds",
                method: "GET",
                params: {
                    page,
                    size,
                    status: status || undefined,
                },
            }),
        {
            refetchOnWindowFocus: false,
        }
    );
};


export default GetAllRefunds;